import { render, staticRenderFns } from "./FlowMyBusinessForm.vue?vue&type=template&id=a6a54a4e"
import script from "./FlowMyBusinessForm.vue?vue&type=script&lang=js"
export * from "./FlowMyBusinessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports